import React from 'react';
import { ExternalLink, FileSpreadsheet, BarChart3, Calendar, Package } from 'lucide-react';

const ExternalLinks = () => {
  const links = [
    {
      label: 'Ανάλυση προσωρινής',
      url: 'https://myeo.e-organizer.gr/index.php?module=Prosoriniapothiki&view=List&mid=1394&parent=1168',
      icon: Package,
      color: 'orange',
    },
    {
      label: 'Αρώματα-Καλλυντικά',
      url: 'https://myeo.e-organizer.gr/report_prosigia.php',
      icon: BarChart3,
      color: 'orange',
    },
    {
      label: 'Season Stock',
      url: 'https://myeo.e-organizer.gr/season_stock.php',
      icon: Calendar,
      color: 'orange',
    },
    {
      label: 'Παρακολούθηση Παραλαβών',
      url: 'https://myeo.e-organizer.gr/npParalaves.php',
      icon: Package,
      color: 'orange',
    },
    {
      label: 'Παρακολούθηση Αναμενόμενων',
      url: 'https://myeo.e-organizer.gr/npAnamenomena.php',
      icon: Package,
      color: 'orange',
    },
  ];

  return (
    <div className="mt-6 rounded-lg border border-orange-200 bg-orange-50 p-4">
      <h3 className="mb-3 flex items-center gap-2 text-sm font-semibold text-orange-800">
        <ExternalLink className="h-4 w-4" />
        EΞωτερικές Αναφορές
      </h3>
      <div className="flex flex-wrap gap-2">
        {links.map((link) => {
          const Icon = link.icon;
          return (
            <a
              key={link.label}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 rounded-lg bg-orange-100 px-3 py-2 text-sm text-orange-800 hover:bg-orange-200 transition-colors"
            >
              <Icon className="h-4 w-4" />
              {link.label}
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default ExternalLinks;
